/**
 * @generated SignedSource<<723b3ac8a7b187c136c463dff552fed1>>
 * @relayHash 826e32a782d6c914902f0dd48681143e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type userHasRovoDevAgentsAccessQuery$variables = {
  atlassianAccountId: string;
  cloudId: string;
};
export type userHasRovoDevAgentsAccessQuery$data = {
  readonly devai_rovoDevAgentsUser: {
    readonly hasProductAccess: boolean | null | undefined;
  };
};
export type userHasRovoDevAgentsAccessQuery = {
  response: userHasRovoDevAgentsAccessQuery$data;
  variables: userHasRovoDevAgentsAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "atlassianAccountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "atlassianAccountId",
      "variableName": "atlassianAccountId"
    },
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "DevAiUser",
  "kind": "LinkedField",
  "name": "devai_rovoDevAgentsUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasProductAccess"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "userHasRovoDevAgentsAccessQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "devai_rovoDevAgentsUser"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userHasRovoDevAgentsAccessQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "6cc503e1004536c657beb712f31ebd0b4deb94e2a5cca8f7225c3cc502ece7d6",
    "metadata": {},
    "name": "userHasRovoDevAgentsAccessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2211f981812c18f10eb7045dcff65aae";

export default node;
